/**
 * @vuelto-surface
 * mobile: ok
 * desktop: n/a
 * strategy: inherit
 */
import React from 'react';
import { formatLocalDate } from '@shared/vueltoDateTime';
import type { BrandRecord } from '../../domain/catalogBrandTypes';
import { TicketListRow } from '../../../shared/ticket/TicketListRow';

type BrandMasterCardProps = {
  brand: BrandRecord;
  onPress: () => void;
};

export function BrandMasterCard({ brand, onPress }: BrandMasterCardProps) {
  const metaParts: string[] = [];
  if (brand.code?.trim()) metaParts.push(`Código: ${brand.code.trim()}`);
  if (brand.defaultMarkupPercent != null) metaParts.push(`Margen: ${brand.defaultMarkupPercent}%`);
  if (brand.createdAt) metaParts.push(`Creada: ${formatLocalDate(brand.createdAt)}`);

  return (
    <TicketListRow
      title={brand.name}
      subtitle={brand.website?.trim() || null}
      meta={metaParts.length > 0 ? metaParts.join(' · ') : null}
      statusLabel={brand.isActive ? 'Activa' : 'Inactiva'}
      statusTone={brand.isActive ? 'ok' : 'bad'}
      inactive={!brand.isActive}
      onPress={onPress}
      accessibilityLabel={`Ver detalle de ${brand.name}`}
    />
  );
}
